/**
 * BottomTabs - Mobile navigation (<768px)
 *
 * Features:
 * - Fixed bottom position with safe-area-inset
 * - 3 primary tabs (Dashboard, Portfolio, Insights)
 * - Compact touch targets
 * - V3: Charcoal active state (no teal)
 *
 * Entry to pricing is via Dashboard hero card or Portfolio header action.
 */

import { Activity, LayoutGrid, TrendingUp } from 'lucide-react';
import { NavItem } from '@/components/ui/NavItem';
import { T } from '@/styles/tokens';

export function BottomTabs() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 flex z-sticky"
      style={{
        height: 82,
        paddingBottom: 'var(--safe-area-inset-bottom, 0px)',
        backgroundColor: T.white,
        boxShadow: T.shadowRaised,
      }}
      aria-label="Main navigation"
    >
      <NavItem to="/app/dashboard" icon={Activity} label="Dashboard" variant="bottom" />
      <NavItem to="/app/portfolio" icon={LayoutGrid} label="Portfolio" variant="bottom" />
      <NavItem to="/app/insights" icon={TrendingUp} label="Insights" variant="bottom" />
    </nav>
  );
}

export default BottomTabs;
